module.exports = __webpack_public_path__ + "static/value-d7a54a8d0b29fed5156627e6eded6b1f.svg";